export default function Footer() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="bg-orange-500">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        {/* Top Section */}
        <div className="grid md:grid-cols-2 lg:grid-cols-12 gap-12 mb-12">
          {/* Brand Section */}
          <div className="lg:col-span-5">
            <div className="flex items-center space-x-3 mb-6">
              <img 
                src="https://public.readdy.ai/ai/img_res/aa3866b7-8f5a-4821-82b3-230471c422eb.png" 
                alt="EL VERDE S.R.L. Logo" 
                className="h-10 w-10 object-contain"
              />
              <h3 className="text-2xl font-bold text-white">EL VERDE S.R.L.</h3>
            </div>
            <p className="text-white/90 text-base leading-relaxed mb-8">
              Your trusted partner in digital privacy and security solutions
            </p>
            <div className="flex space-x-4">
              <a
                href="#"
                className="w-10 h-10 border-2 border-white/30 rounded-full flex items-center justify-center text-white hover:bg-white hover:text-orange-500 transition-all cursor-pointer"
              >
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 border-2 border-white/30 rounded-full flex items-center justify-center text-white hover:bg-white hover:text-orange-500 transition-all cursor-pointer"
              >
                <i className="ri-twitter-x-fill text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 border-2 border-white/30 rounded-full flex items-center justify-center text-white hover:bg-white hover:text-orange-500 transition-all cursor-pointer"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 border-2 border-white/30 rounded-full flex items-center justify-center text-white hover:bg-white hover:text-orange-500 transition-all cursor-pointer"
              >
                <i className="ri-instagram-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="lg:col-span-3">
            <h4 className="text-sm font-bold text-white uppercase tracking-wider mb-6">
              QUICK LINKS
            </h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('home')}
                  className="text-white/90 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('vpn-service')}
                  className="text-white/90 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  VPN Service
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('features')}
                  className="text-white/90 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  Features
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-white/90 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  About
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-white/90 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Image */}
          <div className="lg:col-span-4">
            <div className="rounded-2xl overflow-hidden h-64">
              <img
                src="https://public.readdy.ai/ai/img_res/bb19146f5dae4606f5dc0af7311ee66f.jpg"
                alt="Argentina Landscape"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="pt-8 border-t border-white/20">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-white/80 text-sm">
              © 2025 EL VERDE S.R.L. All rights reserved
            </p>
            <div className="flex items-center space-x-6">
              <a href="#" className="text-white/80 hover:text-white text-sm transition-colors cursor-pointer">
                Privacy Policy
              </a>
              <a href="#" className="text-white/80 hover:text-white text-sm transition-colors cursor-pointer">
                Terms of Service
              </a>
              <a 
                href="https://readdy.ai/?ref=logo" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-white/80 hover:text-white text-sm transition-colors cursor-pointer"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
